import { ClientMetricsLogger } from './clientMetricsLogger.esm.js';
import { Experiments } from './experiments.esm.js';
import { TypeaheadEventLogger } from './typeaheadEventLogger.esm.js';
import { Utils } from './utils.esm.js';

var TypeaheadLogger = /** @class */ (function () {
    function TypeaheadLogger(analytics, clientLogger, experiments) {
        try {
            Experiments.init(experiments);
            Utils.init(clientLogger);
            this.tel = new TypeaheadEventLogger(analytics);
            this.cml = new ClientMetricsLogger(clientLogger);
        }
        catch (e) {
            Utils.logError(e);
        }
    }
    TypeaheadLogger.prototype.initLogger = function (metadata) {
        this.metadata = metadata;
    };
    TypeaheadLogger.prototype.logTypeaheadOpen = function (prefill) {
        var _a, _b, _c, _d;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.initLogger(this.metadata);
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.initLogger(this.metadata);
            (_c = this.tel) === null || _c === void 0 ? void 0 : _c.logTypeaheadOpen(prefill);
            (_d = this.cml) === null || _d === void 0 ? void 0 : _d.logTypeaheadOpen(prefill);
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logTypeaheadRequest = function (query) {
        var _a, _b;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logTypeaheadRequest(query);
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logTypeaheadRequest(query);
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logTypeaheadResponse = function (response) {
        var _a;
        try {
            this.prevResponse = this.response;
            this.response = response;
            (_a = this.cml) === null || _a === void 0 ? void 0 : _a.logTypeaheadResponse(response);
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logSuggestionShown = function (query) {
        var _a, _b, _c, _d;
        try {
            if (query === ((_a = this.response) === null || _a === void 0 ? void 0 : _a.q)) {
                this.shownResponse = this.response;
            }
            else {
                this.shownResponse = query === ((_b = this.prevResponse) === null || _b === void 0 ? void 0 : _b.q) ? this.prevResponse : undefined;
            }
            if (this.shownResponse) {
                (_c = this.tel) === null || _c === void 0 ? void 0 : _c.logTypeaheadResponse(this.shownResponse);
                (_d = this.cml) === null || _d === void 0 ? void 0 : _d.logSuggestionShown(this.shownResponse);
            }
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logSuggestionSelected = function (selected) {
        var _a, _b, _c;
        try {
            if (this.shownResponse && selected) {
                // eslint-disable-next-line no-param-reassign
                if (selected.displayType === 'CATEGORIZED')
                    selected.index += 1;
                var m = (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logSuggestionSelected(selected);
                (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logSuggestionSelected(selected, m);
                this.resetResponse();
            }
            if (!selected) {
                // Then user selects resolve path
                (_c = this.tel) === null || _c === void 0 ? void 0 : _c.isResolveNoSuggestionSelected(true);
            }
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logResponse = function (response) {
        var _a, _b;
        try {
            if (!response.ok) {
                (_a = this.cml) === null || _a === void 0 ? void 0 : _a.logError(response.status);
            }
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logResponse(response);
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logTypeaheadBlurEvent = function () {
        var _a, _b;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logTypeaheadBlurEvent();
            (_b = this.cml) === null || _b === void 0 ? void 0 : _b.logTypeaheadClientMetrics();
            this.resetResponse();
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.logWizardSubmitEvent = function () {
        var _a;
        try {
            (_a = this.tel) === null || _a === void 0 ? void 0 : _a.logWizardSubmitEvent();
        }
        catch (e) {
            Utils.logError(e);
        }
    };
    TypeaheadLogger.prototype.resetResponse = function () {
        this.prevResponse = this.response;
        this.response = this.shownResponse;
        this.shownResponse = undefined;
    };
    return TypeaheadLogger;
}());

export { TypeaheadLogger };
